@if (loading) {
  <div class="items">
    @for (placeholder of skeletonPosts; track $index) {
      <div class="item row">
        <div class="col-3 date">
          <skeleton width="70%"></skeleton>
        </div>
        <div class="col-9 title">
          <skeleton width="90%"></skeleton>
        </div>
      </div>
    }
  </div>
} @else {
  <div class="items">
    @for (item of data?.posts; track item.link) {
      <a [href]="item.link" target="_blank" rel="noopener" class="item row">
        <div class="col-3 date">{{ item.createdAt | date }}</div>
        <div class="col-9 title" [innerHTML]="item?.title"></div>
      </a>
    }
  </div>
}
